"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMenuSearchList = exports.searchMenuIndex = exports.buildMenuSearchIndex = exports.stationHasVisibleTrains = void 0;
const getSearchValue = (value) => (value === null || value === void 0 ? void 0 : value.toLowerCase()) || "";
const isSearchTrain = (item) => "TrainId" in item;
const stationHasVisibleTrains = (treeStation) => {
    var _a, _b, _c;
    if ((_a = treeStation.Trains) === null || _a === void 0 ? void 0 : _a.some(({ TrainId }) => TrainId)) {
        return true;
    }
    return (_c = (_b = treeStation.children) === null || _b === void 0 ? void 0 : _b.some(exports.stationHasVisibleTrains)) !== null && _c !== void 0 ? _c : false;
};
exports.stationHasVisibleTrains = stationHasVisibleTrains;
const buildMenuSearchIndex = (items) => {
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return [];
    }
    const index = [];
    const addStation = (station, parentNames) => {
        index.push({
            item: Object.assign(Object.assign({}, station), { parentNames }),
            searchValue: getSearchValue(station.Name),
        });
    };
    const addTrain = (train, parentId, parentNames) => {
        if (!train.TrainId) {
            return;
        }
        index.push({
            item: Object.assign(Object.assign({}, train), { ParentId: parentId, ParentsNames: parentNames }),
            searchValue: getSearchValue(train.TrainName),
        });
    };
    const walk = (stations, parentNames) => {
        for (const station of stations) {
            const nextParentNames = [...parentNames, station.Name];
            if ((0, exports.stationHasVisibleTrains)(station)) {
                addStation(station, parentNames);
            }
            for (const train of station.Trains) {
                addTrain(train, station.Id, nextParentNames);
            }
            walk(station.children, nextParentNames);
        }
    };
    walk(items, []);
    return index;
};
exports.buildMenuSearchIndex = buildMenuSearchIndex;
const searchMenuIndex = (index, query) => {
    const normalizedQuery = query === null || query === void 0 ? void 0 : query.trim().toLowerCase();
    if (!normalizedQuery) {
        return null;
    }
    if (!index.length) {
        return [];
    }
    const result = [];
    const stationIds = new Set();
    const trainIds = new Set();
    for (const { item, searchValue } of index) {
        if (!searchValue.includes(normalizedQuery)) {
            continue;
        }
        if (isSearchTrain(item)) {
            if (!item.TrainId || trainIds.has(item.TrainId)) {
                continue;
            }
            trainIds.add(item.TrainId);
            result.push(item);
            continue;
        }
        if (stationIds.has(item.Id)) {
            continue;
        }
        stationIds.add(item.Id);
        result.push(item);
    }
    return result;
};
exports.searchMenuIndex = searchMenuIndex;
const buildMenuSearchList = (items, query) => (0, exports.searchMenuIndex)((0, exports.buildMenuSearchIndex)(items), query);
exports.buildMenuSearchList = buildMenuSearchList;
//# sourceMappingURL=search-list.js.map